import Icon from "@mui/icons-material/AccountBalanceWallet";
import { ProjectList } from "./ProjectList";
import { ProjectCreate } from "./ProjectCreate";
import { ProjectEdit } from "./ProjectEdit";
import { ProjectShow } from "./ProjectShow";

export default {
  list: ProjectList,
  create: ProjectCreate,
  edit: ProjectEdit,
  show: ProjectShow,
  icon: Icon,
  label: "Projects",
  options: { label: "Projects" },
  name: "projects",
};
